import {Component, Injector, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {LoaderService} from '../../services/loader.service';
import {UserComponent} from '../users/user/user.component';
import {UserService} from '../../services/user.service';
import {Practice} from '../practices/practices/practice';
import {PracticesService} from '../../services/practices.service';
import {ChangePasswordComponent} from '../change-password/change-password.component';
import {AlertService} from '../../_alert';

@Component({
  selector: 'app-user-profile-settings',
  templateUrl: './user-profile-settings.component.html',
  styleUrls: ['./user-profile-settings.component.scss']
})
export class UserProfileSettingsComponent implements OnInit, OnDestroy {
  show_attachment_popup = false;
  settingsOf: any;
  userComponent: any = UserComponent;
  changePasswordComponent: any = ChangePasswordComponent;
  custom_injector: Injector;
  practice: Practice = new Practice();
  allowClinicalAlertEmails = false;
  allowClinicalAlertsSms = false;
  allowCallBot = false;
  callBotTimeFrom = '08:00';
  callBotTimeTo = '22:00';
  availableAlertSeverities: string[] = [];
  alertSeverityPreferences: string[] = [];
  constructor(private route: ActivatedRoute, private location: Location, public loaderService: LoaderService,
              public injector: Injector, public userService: UserService,
              public practiceService: PracticesService, public alertService: AlertService) {}

  ngOnInit() {
    this.userService.showHideSideBar = true;
    this.route.queryParams.subscribe(params => {
      this.settingsOf = params['settingsOf'];
      if (this.settingsOf) {
        this.setSettingTab(this.settingsOf);
      }
    });
    this.setCustomInjector();
  }

  goBack(): void {
    this.location.back();
  }

  handle_image_upload(data) {
    if (data && data.hasOwnProperty('error') === false) {
      this.userService.current_user.profile_pic =  data.profile_pic;
    }
  }
  choose_file() {
    this.show_attachment_popup = true;
    setTimeout( () => {
      this.show_attachment_popup = false;
    }, 75);
  }

  setCustomInjector() {
    this.custom_injector  = Injector.create([
      {provide: 'id', useValue: this.userService.current_user.id},
      {provide: 'profile_type', useValue: this.userService.current_user.profileable_type},
      {provide: 'profileable_id', useValue: this.userService.current_user.profileable_id},
      {provide: 'is_profile_setting_component', useValue: true},
    ], this.injector);
  }

  fetchPractice(id: number) {
    this.loaderService.show()
    this.practiceService.getPractice(id).then(practice => {
      this.practice.load_from_json(practice)
      this.loaderService.hide();
    }).catch(error => {
      console.error('Error fetching practice:', error);
      this.loaderService.hide();
    });
  }

  loadUserPreferences(id): void {
    this.userService.getUserAlertPreferences(id).subscribe((data) => {
      this.allowClinicalAlertEmails = data.allow_clinical_alert_emails;
      this.allowClinicalAlertsSms = data.allow_clinical_alerts_sms;
      this.allowCallBot = data.allow_call_bot || false;
      this.callBotTimeFrom = data.call_bot_time_from || '08:00';
      this.callBotTimeTo = data.call_bot_time_to || '22:00';
      this.alertSeverityPreferences = data.alert_severity_preferences || [];
      this.availableAlertSeverities = data.available_alert_severities || [];
    });
  }

  isSeveritySelected(severity: string): boolean {
    return this.alertSeverityPreferences.includes(severity);
  }

  toggleSeverity(severity: string, isChecked: boolean): void {
    if (isChecked) {
      if (!this.alertSeverityPreferences.includes(severity)) {
        this.alertSeverityPreferences.push(severity);
      }
    } else {
      const index = this.alertSeverityPreferences.indexOf(severity);
      if (index > -1) {
        this.alertSeverityPreferences.splice(index, 1);
      }
    }
    this.updatePreference();
  }

  updatePreference(type?: string, event?: any): void {
    this.loaderService.show();
    const updatedPreferences = {
      allow_clinical_alert_emails: this.allowClinicalAlertEmails,
      allow_clinical_alerts_sms: this.allowClinicalAlertsSms,
      alert_severity_preferences: this.alertSeverityPreferences,
      allow_call_bot: this.allowCallBot,
      call_bot_time_from: this.callBotTimeFrom,
      call_bot_time_to: this.callBotTimeTo
    };
    this.userService.updateUserAlertPreferences(this.userService.current_user.id, updatedPreferences)
      .subscribe(
        response => {
          this.loaderService.hide();
          this.alertService.success(response.message, this.alertService.options);

          console.log(response.message);
        },
        error => {
          this.loaderService.hide();
          this.alertService.error('Failed to update preferences', this.alertService.options);
        }
        );


  }

  setSettingTab(settingsOf: any) {
    this.settingsOf = settingsOf;
    if (settingsOf === 'preferences') {
      if (this.userService.current_user.practices_id[0]){
        this.loadUserPreferences(this.userService.current_user.id);
        this.fetchPractice(this.userService.current_user.practices_id[0])
      }
    }
  }

  ngOnDestroy(): void {
    this.userService.showHideSideBar = false;
  }

  showHeading(settingsOf: string): string {
    const headingMap: { [key: string]: string } = {
      'profile': 'My Profile',
      'preferences': 'User Preferences',
      'change-password': 'Change Password'
    };

    return headingMap[settingsOf] || '';
  }
}
